export default __webpack_public_path__ + "/dist/images/6989508.d0096b309d12924aac01c37eb41ebedc.png";